import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button"];

  connect() {
    console.log('SavePageController connected');

    this.buttonTarget.addEventListener("click", this.savePage.bind(this));
  }

  async savePage() {
    const savePageUrl = this.buttonTarget.dataset.savePageUrl;
    const pageMain = document.getElementById('pageBody')?.outerHTML || '';
    const pageHead = document.getElementById('pageHead')?.outerHTML || '';
    const pageStyle = document.getElementById('pageStyle')?.outerHTML || '';
    const pageJs = document.getElementById('pageJs')?.outerHTML || '';

    try {
      const response = await fetch(savePageUrl, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        },
        body: JSON.stringify({ tutor_html_page: { head: pageHead, main: pageMain, style: pageStyle, js: pageJs } }),
      });

      if (response.ok) {
        this.showToaster("Page saved successfully!");
      } else {
        this.showToaster("Failed to save page!");
      }
    } catch (error) {
      console.error("Error saving page:", error);
      this.showToaster("An error occurred while saving the page.");
    }
  }

  showToaster(message, duration = 3000) {
    let toasterContainer = document.getElementById('toaster-container');
    if (!toasterContainer) {
      toasterContainer = document.createElement('div');
      toasterContainer.id = 'toaster-container';
      toasterContainer.style.position = 'fixed';
      toasterContainer.style.top = '20px';
      toasterContainer.style.right = '20px';
      toasterContainer.style.zIndex = '1000';
      toasterContainer.style.display = 'flex';
      toasterContainer.style.flexDirection = 'column';
      toasterContainer.style.gap = '10px';
      document.body.appendChild(toasterContainer);
    }

    const toaster = document.createElement('div');
    toaster.textContent = message;
    toaster.style.background = '#333';
    toaster.style.color = '#fff';
    toaster.style.padding = '10px 20px';
    toaster.style.borderRadius = '5px';
    toaster.style.boxShadow = '0 2px 5px rgba(0, 0, 0, 0.3)';
    toaster.style.opacity = '0';
    toaster.style.transition = 'opacity 0.3s ease';

    toasterContainer.appendChild(toaster);

    setTimeout(() => {
      toaster.style.opacity = '1';
    }, 10);

    setTimeout(() => {
      toaster.style.opacity = '0';
      setTimeout(() => toaster.remove(), 300);
    }, duration);
  }
}
